export const scheduleForBrandAndType = ({ schedules, brand, type, scheduleKey }) => {
  const result = schedules.find((schedule) => schedule.brand === brand && schedule.type === type);
  if (result) {
    return result[scheduleKey];
  }
};
